/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboDeclarationBadRequestResponse,
  BboDeclarationFailureResponseResponse,
  ForbiddenResponse,
  MonthlyStatementResponseResponse,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * @summary Get Monthly Balance statement by declarationId
 */
export const getMbStatementByDeclarationId = (
  mbStatementDeclarationID: string,
  signal?: AbortSignal,
) => {
  return customInstance<MonthlyStatementResponseResponse>({
    url: `/bm-declaration-service/v1/monthlyBalance/statement/${mbStatementDeclarationID}`,
    method: 'get',
    signal,
  });
};

export const getGetMbStatementByDeclarationIdQueryKey = (mbStatementDeclarationID: string) => {
  return [
    `/bm-declaration-service/v1/monthlyBalance/statement/${mbStatementDeclarationID}`,
  ] as const;
};

export const getGetMbStatementByDeclarationIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getMbStatementByDeclarationId>>,
  TError = ErrorType<
    | BboDeclarationBadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | BboDeclarationFailureResponseResponse
  >,
>(
  mbStatementDeclarationID: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMbStatementByDeclarationId>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMbStatementByDeclarationIdQueryKey(mbStatementDeclarationID);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMbStatementByDeclarationId>>> = ({
    signal,
  }) => getMbStatementByDeclarationId(mbStatementDeclarationID, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!mbStatementDeclarationID,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getMbStatementByDeclarationId>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetMbStatementByDeclarationIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMbStatementByDeclarationId>>
>;
export type GetMbStatementByDeclarationIdQueryError = ErrorType<
  | BboDeclarationBadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | BboDeclarationFailureResponseResponse
>;

/**
 * @summary Get Monthly Balance statement by declarationId
 */
export const useGetMbStatementByDeclarationId = <
  TData = Awaited<ReturnType<typeof getMbStatementByDeclarationId>>,
  TError = ErrorType<
    | BboDeclarationBadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | BboDeclarationFailureResponseResponse
  >,
>(
  mbStatementDeclarationID: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMbStatementByDeclarationId>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetMbStatementByDeclarationIdQueryOptions(
    mbStatementDeclarationID,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
